let identifiedUserId: number | null = null

/**
 * HubSpot tracking for single-page application page views.
 * Tracks page views when navigating between routes.
 */
export function useHubspotTracking() {
  // Paths to ignore for tracking.
  const ignoredPaths = computed(() => {
    const ignoredPaths: (string | RegExp)[] = ['/one-time-case', '/external-onboarding']

    if (!stores.organization.account_access_consent) {
      ignoredPaths.push(/\/cases\/[a-f0-9-]+/, /\/clients\/[a-f0-9-]+/, /\/client-onboarding\/clients\/[a-f0-9-]+/, /\/transaction-monitoring\/clients\/[a-f0-9-]+/)
    }

    return ignoredPaths
  })

  /**
   * Identifies the user in HubSpot tracking if they are authenticated.
   */
  function identify() {
    if (!stores.user.authenticated || !window._hsq) {
      return null
    }

    const user = stores.user.user
    // Skip if already identified for this user.
    if (identifiedUserId === user.id) {
      return identifiedUserId
    }

    window._hsq.push([
      'identify',
      {
        email: user.email,
        firstname: user.first_name,
        lastname: user.last_name,
      },
    ])
    identifiedUserId = user.id

    return identifiedUserId
  }

  /**
   * Track a page view in HubSpot.
   * @param path The path to track (defaults to current location).
   */
  function trackPageView(path: string) {
    if (!window._hsq) {
      return
    }

    // Handle both #/path and /path formats.
    const normalizedPath = path.startsWith('/#') ? path.slice(2) : path

    if (ignoredPaths.value.some((ignoredPath) => (ignoredPath instanceof RegExp ? ignoredPath.test(normalizedPath) : normalizedPath.startsWith(ignoredPath)))) {
      return
    }

    if (identify()) {
      window._hsq.push(['setPath', path])
      window._hsq.push(['trackPageView'])
    }
  }

  return { trackPageView, identify }
}
